// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Image: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 47.8"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M36.6 10.8c-2.5 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6c2.5 0 4.6-2.1 4.6-4.6 0-2.6-2-4.6-4.6-4.6zm1.8 4.5c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8.8-1.8 1.8-1.8 1.8.8 1.8 1.8z"/><path d="M52 1.2H2.1c-.6 0-1 .4-1 1v43.5c0 .6.4 1 1 1H52c.6 0 1-.4 1-1V2.2c0-.6-.4-1-1-1zM3.8 32.4l11.1-11c.2-.2.5-.4.8-.4.3 0 .6.1.9.3l16.1 16.1c.3.3.8.4 1.1.4.3 0 .6-.2.8-.4l8.3-7.8c.3-.3.5-.4.9-.4.3 0 .5.1.7.4l5.7 6.2V44H3.8V32.4zM41 27.6l-7.3 6.9-15.2-15.2c-.8-.8-1.7-1.1-2.8-1.1-1.1 0-2.1.4-2.8 1.1l-9 9V3.9h46.4v27.7l-3.7-4c-1.7-1.5-4.1-1.5-5.6 0z"/></svg>;
};

export default React.memo(Image);
